<style scoped>
.el-col-5 {
  width: 30%;
}
.chooseBox {
  display: flex;
  /* justify-content: center; */
  /* margin-top: 30px; */
}
.upload-txt {
  line-height: 6px;
}
.select-box {
  overflow: hidden;
  margin: 0 0px 10px 30px;
}
.box-left {
  width: 40%;
  height: 350px;
  padding: 0 20px 20px 20px;
  border: 1px solid #bbb;
  box-sizing: border-box;
  overflow-y: auto;
}
.box-right {
  width: 57%;
  height: 350px;
  padding: 0 10px 20px 20px;
  border: 1px solid #bbb;
  box-sizing: border-box;
}
.txt-color {
  text-decoration: none;
}
.clear-person {
  color: #4fa1a4;
  float: right;
  margin-right: 20px;
  text-decoration: underline;
  cursor: pointer;
}
.form-box {
  display: flex;
  flex-wrap: wrap;
}
.form-box .form-list {
  display: flex;
  width: 48%;
  margin-bottom: 20px;
  padding: 0 2%;
  box-sizing: border-box;
}
.form-box .form-list label {
  width: 120px;
  flex-shrink: 0;
  text-align: right;
  line-height: 36px;
}
.form-box .form-list label span {
  color: red;
}
.form-box .form-list .form-input {
  flex: 1;
  width: 100%;
}
.form-box .form-list .form-input p {
  color: #4fa1a4;
  text-align: left;
  margin-bottom: 0 !important;
}
.W250 {
  width: 250px;
}
.search-area .rows{
  display: flex;
  flex-wrap: nowrap;
}
.search-area-div{
  word-break: keep-all;
  width: 110px;
}
</style>
<template>
  <div class="content">
    <div class="search-area">
      <el-row :gutter="24">
        <el-col :span="6" class="rows"><div class="search-area-div">姓名/手机号：</div>
          <el-input class="ipt-sty" size="mini" v-model="page.staffName" placeholder="请输入姓名/手机号"></el-input>
        </el-col>
        <el-col :span="6" class="rows">
          <div class="search-area-div">核算单元：</div>
          <el-select class="ipt-sty" size="mini" v-model="page.unitGuid" placeholder="请选择" >
            <el-option v-for="item in bizUnitNameOptions" :key="item.guid" :label="item.label" :value="item.guid">
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="6" class="rows">
          <div class="search-area-div">账单月份：</div>
          <el-date-picker
            class="ipt-sty"
            size="mini"
            value-format="yyyy-MM"
            v-model="page.accountMonth"
            type="month"
            :clearable="false"
            placeholder="选择月"
          >
          </el-date-picker>
        </el-col>
        <el-col :span="6" class="search-btn-box">
          <el-button size="mini" type="text" @click="showMore = !showMore"
            :icon="showMore ? 'el-icon-arrow-up' : 'el-icon-arrow-down'">
            {{ showMore? '收起筛选': '更多筛选' }}
          </el-button>
          <el-button size="mini" type="info" @click="getData(true)">搜索</el-button>
          <el-button size="mini" type="danger" @click="empty">清空</el-button>
        </el-col>
      </el-row>
      <el-row :gutter="24" class="mt15" v-show="showMore">
        <el-col :span="6" class="rows">
          <div class="search-area-div">账单周期：</div>
          <el-select class="ipt-sty" size="mini" v-model="page.billCycle" placeholder="请选择" >
            <el-option v-for="item in billCycleOption" :key="item" :label="item" :value="item">
            </el-option>
          </el-select>
        </el-col>
      </el-row>
    </div>
    <div class="button-area btn-box">
      <el-button  size="mini" type="info" @click="repeatCalc">重新计算</el-button>
      <el-button  size="mini" type="info" @click="bitchProduce">批量导入</el-button>
      <el-button  size="mini" type="info" @click="bitchExport">批量导出</el-button>

    </div>
    <div class="back-color-fff  content-main-box"  :style="'height:' + contentMainHeight + 'px;'"  v-loading.fullscreen.lock="fullscreenLoading">
      <el-table
        :data="tableData"
        @selection-change="handleSelectionChange"
        stripe border
        v-loading="tableWrapLoading"
        style="width: 100%"
        :height="tableHeight"
      >
        <el-table-column type="selection" width="60" header-align="center" align="center"></el-table-column>
        <el-table-column label="序号" width="60" header-align="center" align="center">
          <template slot-scope="scope">
            <!-- {{ scope.$index + 1 }} -->
            {{ (page.pageIndex - 1) * page.pageSize + scope.$index + 1 }}
          </template>
        </el-table-column>
        <el-table-column
          prop="accountMonth"
          label="核算月份"
          header-align="center"
          align="left"
          show-overflow-tooltip
          width="100"
        >
          <template slot-scope="scope">{{ scope.row.accountMonth | getMonth }}</template>
        </el-table-column>
      
        <el-table-column
          prop="staffName"
          label="姓名"
          header-align="center"
          align="left"
          show-overflow-tooltip
          width="100"
        ></el-table-column>
        <el-table-column
          prop="mobileNo"
          label="手机号"
          header-align="center"
          align="left"
          show-overflow-tooltip
          width="120"
        ></el-table-column>
        <el-table-column
          prop="organisationName"
          label="部门"
          header-align="center"
          align="left"
          show-overflow-tooltip
          min-width="180"
        >
           <template slot-scope="scope">{{ scope.row.organisationName || '-' }}</template>
        </el-table-column>
        <el-table-column
          prop="billCycle"
          label="账单周期"
          header-align="center"
          align="left"
          show-overflow-tooltip
          width="100"
        >
          <template slot-scope="scope">{{ scope.row.billCycle||'-' }}</template>
        </el-table-column>
        <el-table-column
          prop="billCycle"
          label="周期范围"
          header-align="center"
          align="left"
          width="190"
        >
        <template slot-scope="scope">{{scope.row.cycleStartDate ? scope.row.cycleStartDate + ' 至 ' + scope.row.cycleEndDate : '-'}}</template>
        </el-table-column>
        <el-table-column
          prop="taskSalary"
          label="核算单元"
          header-align="center"
          align="left"
          show-overflow-tooltip
          width="120"
        >
          <template slot-scope="scope">{{ scope.row.unitName || '-' }}</template>
        </el-table-column>
        <el-table-column
          prop="workDay"
          label="理论考勤天数"
          header-align="center"
          align="right"
          show-overflow-tooltip
          width="110"
        >
          <template slot-scope="scope">{{ scope.row.workDay || '-' }}</template>
        </el-table-column>
        <el-table-column
          prop="realWorkDay"
          label="实际考勤天数"
          header-align="center"
          align="right"
          show-overflow-tooltip
          width="110"
        >
          <template slot-scope="scope">{{ scope.row.realWorkDay || '-' }}</template>
        </el-table-column>

        <el-table-column
          prop="score"
          label="月行为考核分值"
          header-align="center"
          align="right"
          show-overflow-tooltip
          width="120"
        >
          <template slot-scope="scope">{{ scope.row.score | numDigit}}</template>
        </el-table-column>

        <el-table-column
          prop="insure"
          label="公司承担社保金额(元)"
          header-align="center"
          align="right"
          show-overflow-tooltip
          width="160"
        >
          <template slot-scope="scope">{{ scope.row.insure | numDigit }}</template>
        </el-table-column>

        <el-table-column
          label="公司承担公积金金额(元)"
          header-align="center"
          align="right"
          show-overflow-tooltip
          width="180"
        >
          <template slot-scope="scope">{{ scope.row.fund | numDigit }}</template>
        </el-table-column>

        <el-table-column label="个人承担社保金额(元)" header-align="center" align="right" show-overflow-tooltip width="180">
          <template slot-scope="scope">{{ scope.row.insureSelf | numDigit }}</template>
        </el-table-column>

        <el-table-column
          label="个人承担公积金金额(元)"
          header-align="center"
          align="right"
          show-overflow-tooltip
          width="180"
        >
          <template slot-scope="scope">{{ scope.row.fundSelf | numDigit}}</template>
        </el-table-column>
        <el-table-column label="底薪基数(元)" header-align="center" align="right" show-overflow-tooltip width="150">
          <template slot-scope="scope">{{ scope.row.basicSalary&&scope.row.basicSalary.toFixed(2) | numDigit }}</template>
        </el-table-column>
        <el-table-column label="绩效基数(元)" header-align="center" align="right" show-overflow-tooltip width="150">
          <template slot-scope="scope">{{ scope.row.performanceSalary&&scope.row.performanceSalary | numDigit }}</template>
        </el-table-column>

        <el-table-column label="实际底薪(元)" header-align="center" align="right" show-overflow-tooltip width="150">
          <template slot-scope="scope">{{scope.row.realBaseSalary | numDigit }}</template>
        </el-table-column>

        <el-table-column label="实际行为考核金额(元)" header-align="center" align="right" show-overflow-tooltip width="160">
          <template slot-scope="scope">{{ scope.row.realSaleSalary | numDigit}}</template>
        </el-table-column>
        <el-table-column label="其他(元)" header-align="center" align="right" show-overflow-tooltip width="120">
          <template slot-scope="scope">{{ scope.row.otherSalary | numDigit }}</template>
        </el-table-column>
        <el-table-column label="薪酬合计(元)" header-align="center" align="right" show-overflow-tooltip width="160">
          <template slot-scope="scope">{{ scope.row.totalSalary | numDigit}}</template>
        </el-table-column>

        <el-table-column
          prop="realMoney"
          label="建档条目数"
          header-align="center"
          align="right"
          show-overflow-tooltip
          width="100"
        >
          <template slot-scope="scope">{{ scope.row.taskCreateFileCount || '-' }}</template>
        </el-table-column>

        <el-table-column
          prop="nextMoney"
          label="理货条目数"
          header-align="center"
          align="right"
          show-overflow-tooltip
          width="100"
        >
          <template slot-scope="scope">{{ scope.row.taskSupportPriceCount || '-' }}</template>
        </el-table-column>
      </el-table>
    </div>
    <el-pagination
      class="pt pb back-color-fff content-pagination-box"
      background
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :page-sizes="[10,20,50,100,200]"
      :current-page="page.pageIndex"
      :page-size="page.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="page.totalRows"
    >
    </el-pagination>
  </div>
</template>
<script>
export default {
  data() {
    return {
      tableHeight: window.innerHeight - 260,
      contentMainHeight: window.innerHeight - 240,
      showMore:false,
      input: '',
      title: '添加账单',
      dialogFormVisible: false,
      fullscreenLoading: false,
      tableLoading: false,
      tableWrapLoading: false,
      value2: '',
      companyList: [], //公司选择\
      staffList: [], //人员列表
      idCode: '', //身份证号
      mobileNo: '', //手机号
      page: {
        pageIndex: 1,
        pageSize: 50,
        totalPage: 0,
        totalRows: 0,
        tenantGuid: '',
        staffName: '',
        organisationName: '',
        accountMonth: '',
        unitGuid: '',
      },
      tableData: [],
      multipleSelection: [],
      staffLoading: false,
      billCycle: null, //周期
      billCycleOption: ['一期', '二期', '三期', '四期', '五期', '六期', '七期', '八期', '九期', '十期', '十一期', '十二期', '十三期', '十四期', '十五期', '十六期', '十七期', '十八期', '十九期', '二十期', '二十一期', '二十二期', '二十三期', '二十四期', '二十五期', '二十六期', '二十七期', '二十八期', '二十九期', '三十期'],
      cycleDate: null, //周期范围起止
      pickerOptions: {
        disabledDate: (time) => {
          return (
            time.getTime() < this.getMonthStartOrEnd(1, this.ruleForm.accountMonth) ||
            time.getTime() > this.getMonthStartOrEnd(2, this.ruleForm.accountMonth)
          );
        },
      },
      bizUnitNameOptions:[]
    };
  },
  watch:{
    showMore(val, oldVal) {
      if(val) {
          this.tableHeight = window.innerHeight - 300;
          this.contentMainHeight=window.innerHeight - 280;
          return;
        }
        if(!val) {
          this.tableHeight = window.innerHeight - 260;
          this.contentMainHeight = window.innerHeight - 240;
          return;
        }
    },
  },
  created() {
    // 列表
    // this.getCurrentMonth();
    this.getbizUnitNameOptions();
    this.getData(false);
  },
  methods: {
    getbizUnitNameOptions() {
      let self = this;
      let page = {
        pageIndex: 1,
        pageSize: -1,
        tenantGuid: self.$store.getters.getTenantGuid,
      };
      self.api.postJson(`/${serverConfig.msSalesPerformService}/biz-unit/data/get-biz-unit`, page).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          var list = res.data.data.records;
          self.bizUnitNameOptions = list;
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    getMonthStartOrEnd(type, monthDate) {
      let time = null;
      if (type == 1) {
        time = this.$moment(monthDate).startOf('month').valueOf();
      } else {
        time = this.$moment(monthDate).endOf('month').valueOf();
      }
      return time;
    },
    empty() {
      this.page.pageIndex = 1;
      this.page.pageSize = 50;
      this.page.staffName = '';
      this.page.organisationName = '';
      this.page.unitGuid = '';
      this.page.accountMonth='';
      this.page.billCycle = '';
      this.getData(true);
    },
    getData(flg) {
      let self = this;
      if (flg) {
        self.page.pageIndex = 1;
      }
      let query = JSON.parse(JSON.stringify(self.page));
      query.accountMonth = query.accountMonth.replace('-', '');
      self.tableWrapLoading = true;
      self.api
        .postJson(`/${serverConfig.msSalesPerformService}/tenant-biz/salary/get-list-real`, query)
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            self.tableWrapLoading = false;
            self.tableData = res.data.data.records;
            self.page.totalPage = res.data.data.totalPages;
            self.page.totalRows = res.data.data.totalRows;
          } else {
            self.$message.error(res.data.msg);
          }
        })
        .catch(() => {
          self.tableWrapLoading = false;
        });
    },
    getStaff() {
      if (this.ruleForm.tenantGuid == '' || this.ruleForm.tenantGuid == null) {
        this.$message.error('请先选择药企!');
        return;
      }
    },
    //获取人员列表
    getStaffChange(val) {
      let self = this;
      self.companyList.forEach((i) => {
        if (self.ruleForm.tenantGuid == i.sendTenantGuid) {
          self.ruleForm.tenantName = i.sendTenantName;
        }
      });
      self.ruleForm.staffGuid = val == 1 ? self.ruleForm.staffGuid : '';
      let query = {
        pageIndex: 1,
        pageSize: -1,
        tenantGuid: self.ruleForm.tenantGuid,
      };
      self.staffLoading = true;
      return new Promise((resolve, reject) => {
        self.api.postJson(`/${serverConfig.msPersonnelService}/staff/data/get`, query).then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            self.staffList = res.data.data.records;
            self.staffLoading = false;
            resolve();
          } else {
            self.$message.error(res.data.msg);
          }
        });
      });
    },
    //获取人员详情
    getStaffDetail(guid) {
      let self = this;
      if (self.staffList != null && self.staffList.length > 0) {
        self.staffList.forEach((i) => {
          if (guid == i.guid) {
            self.ruleForm.staffName = i.staffName;
            self.ruleForm.mobileNo = i.mobileNo;
            self.ruleForm.idCode = i.idCode;
          }
        });
      }
    },
    //获取公司
    getCompany() {
      let self = this;
      let query = {
        isService: true,
        tenantGuid: localStorage.guid,
      };
      self.api
        .get(`/${serverConfig.msCustomerService}/tenant/data/get-tenant-operation-rel-list`, query)
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            self.companyList = res.data.data;
            self.page.tenantGuid = self.companyList[0].sendTenantGuid;
            this.getData(false);
          } else {
            self.$message.error(res.data.msg);
          }
        });
    },
    //是否发放
    changetSend(isNotSend, guid) {
      let self = this;
      let req = {
        guid,
        isNotSend,
      };
      self.fullscreenLoading = true;
      self.api.get(`/${serverConfig.msSalesPerformService}/staff-salary-task/data/update-not-send`, req).then((res) => {
      self.fullscreenLoading = false;
       if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.$message.success('操作成功');
          self.getData();
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    isAllEqual(array) {
      if (array.length > 0) {
          return !array.some(function (value, index) {
              return value !== array[0];
          });
      } else {
          return true;
      }
    },
    //重新计算
    repeatCalc() {
      if(this.multipleSelection.length == 0){
        this.$message.error('请选择需要重新计算的数据')
        return;
      }
     
      let staffGuidList = [];
      let accountMonthList = [];
      this.multipleSelection.forEach(item=>{
        staffGuidList.push(item.staffGuid);
        accountMonthList.push(item.accountMonth)
      });
       if(!this.isAllEqual(accountMonthList)){
        this.$message.error('请选择同一个核算月的数据重新计算！')
        return;
      }
      let self = this;
      let req = {
        tenantGuid: localStorage.guid,
        accountMonth: accountMonthList[0],
        progressGuid: this.generateUUID(),
        staffGuidList:staffGuidList,
      };
      self.fullscreenLoading = true;
      self.api.postJson(`/${serverConfig.msSalesPerformService}/tenant-biz/salary/auto-update-real`, req).then((res) => {
        self.fullscreenLoading = false;
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.getData();
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    //批量导入
    bitchProduce() {
      this.$router.push('/insureImport?productGuid='+this.$route.query.productGuid)
    },
    //批量导出
    bitchExport() {
      let self = this;
      let req = {
        pageIndex: 1,
        pageSize: -1,
        unitGuid:this.page.unitGuid,
        organisationName: this.page.organisationName,
        staffName: this.page.staffName,
        accountMonth: this.page.accountMonth.replace('-', ''),
      };
      self.fullscreenLoading = true;
      self.api.postJson(`/${serverConfig.msSalesPerformService}/tenant-biz/salary/export-real`, req).then((res) => {
        self.fullscreenLoading = false;
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.reportJx(res.data.data.colNames, res.data.data.datas, res.data.data.sheetName, res.data.data.fileNam);
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    reportJx(colNames, datas, sheetName, fileNam) {
      let self = this;
      self.api
        .postJsonD(`/${serverConfig.msCommonAdminCloudService}/excel/export`, {
          colNames: colNames,
          datas: datas,
          sheetName: sheetName,
          fileNam: fileNam,
        })
        .then((res) => {
          let blob = new Blob([res.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
          let fileName = fileNam;
          let objectUrl = URL.createObjectURL(blob);
          const link = document.createElement('a');
          link.download = fileName;
          link.href = objectUrl;
          link.click();
        });
    },
    generateUUID() {
      var d = new Date().getTime();
      if (window.performance && typeof window.performance.now === "function") {
        d += performance.now(); //use high-precision timer if available
      }
      var uuid = 'xxxxxxxxxxxx4xxxyxxxxxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        var r = (d + Math.random() * 16) % 16 | 0;
        d = Math.floor(d / 16);
        return (c == 'x' ? r : (r & 0x3 | 0x8)).toString(16);
      });
      return uuid;
    },
    //选择表格数据
    handleSelectionChange(val) {
      let self = this;
      self.multipleSelection = val;
    },
    handleSizeChange(val) {
      let self = this;
      self.page.pageSize = val;
      this.getData();
    },
    handleCurrentChange(val) {
      let self = this;
      self.page.pageIndex = val;
      this.getData();
    },
  },
};
</script>
